import {formatDate, formatDateTime, formatNumber} from "./base_func";
import {mapState} from "vuex";

export let BaseItemData = function () {
  return {
    model: {
      prop: 'show_drawer',
      event: 'change'
    },
    props: {
      id: [Number, String],
      action: String,
      show_drawer: Boolean,
      base_view_url: String,
      item_type: String
    },
    computed: {
      title() {
        return this.titles[this.itemAction];
      },
      showDetailComponent() {
        return this.showDrawer && this.itemAction === 'detail'
      },
      showFormComponent() {
        return this.showDrawer && (this.itemAction === 'edit' || this.itemAction === 'create')
      },

      ...mapState([
        "user_id",
        "user_full_name",
        "current_view",
        "current_view_parent",
        "currency",
        "permissions",
        "role",
        "role_display",
        "use_fiscal",
        "company_name",
        "cashes"
      ])
    },
    methods: {

      // Common actions
      showDetail(id) {
        this.itemAction = 'detail';
        // this.$router.push({name: this.item_type + '_detail', params: {id: id}});
      },
      showEdit(id) {
        this.itemAction = 'edit';
        // this.$router.push({name: this.item_type + '_edit', params: {id: id}});
      },
      showCreate() {
        this.itemAction = 'create';
        // this.$router.push({name: this.item_type + '_create'});
      },

      // User actions
      cancelAction() {
        this.showDrawer = false
      },
      editAction(id) {
        this.showEdit(id);
      },

      // Форматирование
      formatNumber (number) {
        return formatNumber(number);
      },
      formatDate (date) {
        return formatDate(date);
      },
      formatDateTime  (datetime) {
        return formatDateTime(datetime);
      },

    },
    watch: {
      show_drawer: function (newValue, oldValue) {
        this.showDrawer = newValue;
        this.itemAction = this.action;
        this.itemId = this.id;

        if (newValue) {
          if (this.itemAction === 'detail') {
            this.showDetail(this.itemId);
          } else if (this.itemAction === 'edit') {
            this.showEdit(this.itemId);
          } else if (this.itemAction === 'create') {
            this.showCreate();
          }
        } else {
          this.detail = {};
          this.formData = {};
          //this.$router.go(-1);
          this.$router.push({name: this.item_type});
        }

      },
      showDrawer: function (newValue, oldValue) {
        this.$emit('change', newValue);
      },
    },

  }

};



// WEBPACK FOOTER //
// ./src/base/base_item.js